import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { BASE_URL } from "../../Shared/URL.js";
import axiosInstance from "../../Shared/axiosInstance.js";


export default function PurchaseDetails() {
  const { id } = useParams();
  const [purchase, setPurchase] = useState(null);
  const [downloading, setDownloading] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const { data } = await axiosInstance.get(`/Purchase/get-purchase/${id}`);
        setPurchase(data.data);
      } catch (err) {
        console.error("Error fetching purchase details:", err);
        Swal.fire("خطأ", "فشل تحميل تفاصيل الفاتورة", "error");
      }
    };
    fetchDetails();
  }, [id]);

  const handleDownloadPdf = async () => {
    setDownloading(true);
    try {
      const response = await axiosInstance.get(
        `/Purchase/get-purchase-pdf/${id}`,
        { responseType: "blob" }
      );

      if (response.data.type === "application/json") {
        const text = await response.data.text();
        const errorData = JSON.parse(text);
        Swal.fire({
          icon: "error",
          title: "فشل إنشاء ملف PDF",
          text: errorData.message || "حدث خطأ في السيرفر",
        });
        return;
      }

      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `فاتورة_${id}_${new Date().toISOString().split("T")[0]}.pdf`
      );
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      Swal.fire({
        icon: "success",
        title: "تم التحميل",
        text: "تم تحميل ملف PDF بنجاح",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error("Error downloading PDF:", err);

      if (err.response?.data instanceof Blob) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const errorObj = JSON.parse(reader.result);
            Swal.fire({
              icon: "error",
              title: "فشل التحميل",
              text: errorObj.message || "تعذر تحميل ملف PDF",
            });
          } catch {
            Swal.fire("خطأ", "تعذر تحميل ملف PDF", "error");
          }
        };
        reader.readAsText(err.response.data);
      } else {
        Swal.fire({
          icon: "error",
          title: "فشل التحميل",
          text: err.response?.data?.message || "خطأ في الاتصال بالسيرفر",
        });
      }
    } finally {
      setDownloading(false);
    }
  };

  if (!purchase) {
    return (
      <div className="container mt-5 pt-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">جاري التحميل...</span>
        </div>
        <p className="mt-3">جاري تحميل تفاصيل الفاتورة...</p>
      </div>
    );
  }

  const totalPaid = purchase.payments.reduce((sum, p) => sum + p.amount, 0);
  const remaining = purchase.totalAmount - totalPaid;

  return (
    <div className="mt-5 pt-5" dir="rtl">
      {/* Action Buttons */}
<div className="container mb-3" style={{ maxWidth: "900px" }}>
      <div className="d-flex gap-2">
        {/* زر تحميل PDF */}
        <button
          onClick={handleDownloadPdf}
          disabled={downloading}
          style={{
            background: downloading ? "#94a3b8" : "#2563eb",
            color: "white",
            padding: "12px 24px",
            borderRadius: "6px",
            border: "none",
            fontSize: "16px",
            fontWeight: "600",
            cursor: downloading ? "not-allowed" : "pointer",
            boxShadow: "0 2px 8px rgba(37, 99, 235, 0.3)",
            transition: "all 0.3s ease",
          }}
        >
          {downloading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              جاري إنشاء الملف...
            </>
          ) : (
            <>📥 تحميل PDF</>
          )}
        </button>

        {/* زر الرجوع */}
        <button
          className="btn btn-outline-secondary"
          onClick={() => window.history.back()}
        >
          ← رجوع
        </button>

<button
  style={{
    background: "#22c55e",
    color: "#fff",
    padding: "5px 10px",
    borderRadius: "6px",
    border: "none",
    fontWeight: "600",
    fontSize: "17px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    whiteSpace: "nowrap"
  }}
  onClick={() => navigate(`/purchases/${id}/add-payment`)}
>
  إضافة دفعة
</button>

      </div>
    </div>

      {/* Invoice Content */}
      <div className="container mb-5" style={{ maxWidth: "900px" }}>
        <div
          style={{
            background: "#ffffff",
            border: "2px solid #93c5fd",
            borderRadius: "8px",
            padding: "40px",
            boxShadow: "0 4px 12px rgba(59, 130, 246, 0.15)",
          }}
        >
          {/* Header */}
          <div
            style={{
              borderBottom: "3px solid #60a5fa",
              paddingBottom: "20px",
              marginBottom: "30px",
            }}
          >
            <h3
              style={{
                color: "#2563eb",
                fontSize: "32px",
                fontWeight: "700",
                marginBottom: "5px",
              }}
            >
              فاتورة شراء
            </h3>

            <div style={{ color: "#64748b", fontSize: "16px" }}>
              رقم الفاتورة: <strong>{id}</strong>
            </div>

            <div style={{ color: "#64748b", fontSize: "16px" }}>
              التاريخ:{" "}
              {new Date(purchase.purchaseDate).toLocaleDateString("ar-EG")}
            </div>
          </div>

          {/* Supplier Info */}
          <div style={{ marginBottom: "30px" }}>
            <div className="row">
              <div className="col-md-6">
                <div
                  style={{
                    color: "#64748b",
                    fontSize: "14px",
                    marginBottom: "4px",
                  }}
                >
                  المورد
                </div>
                <div
                  style={{
                    color: "#000",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  {purchase.supplierName}
                </div>
                <div
                  style={{
                    color: "#000",
                    fontSize: "20px",
                    fontWeight: "600",
                  }}
                >
                  {purchase.supplierDetails}
                </div>
              </div>

              <div className="col-md-6 text-end">
                <span
                  style={{
                    background:
                      purchase.paymentStatus === "Paid"
                        ? "#dcfce7"
                        : purchase.paymentStatus === "PartiallyPaid"
                        ? "#fef3c7"
                        : "#fee2e2",
                    color:
                      purchase.paymentStatus === "Paid"
                        ? "#15803d"
                        : purchase.paymentStatus === "PartiallyPaid"
                        ? "#b45309"
                        : "#b91c1c",
                    padding: "8px 18px",
                    borderRadius: "6px",
                    fontSize: "16px",
                    fontWeight: "600",
                    border:
                      purchase.paymentStatus === "Paid"
                        ? "1px solid #86efac"
                        : purchase.paymentStatus === "PartiallyPaid"
                        ? "1px solid #fcd34d"
                        : "1px solid #fca5a5",
                    display: "inline-block",
                  }}
                >
                  {purchase.paymentStatus === "Paid"
                    ? "✓ مدفوعة"
                    : purchase.paymentStatus === "PartiallyPaid"
                    ? "⊙ مدفوعة جزئياً"
                    : "✗ غير مدفوعة"}
                </span>
              </div>
            </div>
          </div>

          {/* Items Table */}
          <div style={{ marginBottom: "25px" }}>
            <h5
              style={{
                color: "#2563eb",
                fontSize: "18px",
                fontWeight: "600",
                marginBottom: "12px",
              }}
            >
              المنتجات
            </h5>

            <div className="table-responsive">
              <table
                className="table mb-0"
                style={{ border: "1px solid #dbeafe" }}
              >
                <thead>
                  <tr style={{ background: "#dbeafe" }}>
                    <th
                      style={{
                        color: "#1e40af",
                        fontSize: "15px",
                        padding: "12px",
                        fontWeight: "600",
                        border: "1px solid #bfdbfe",
                      }}
                    >
                      المنتج
                    </th>

                    <th
                      style={{
                        color: "#1e40af",
                        fontSize: "15px",
                        padding: "12px",
                        textAlign: "center",
                        fontWeight: "600",
                        border: "1px solid #bfdbfe",
                      }}
                    >
                      الفئة
                    </th>

                    <th
                      style={{
                        color: "#1e40af",
                        fontSize: "15px",
                        padding: "12px",
                        textAlign: "center",
                        fontWeight: "600",
                        border: "1px solid #bfdbfe",
                      }}
                    >
                      الماركة
                    </th>

                    <th
                      style={{
                        color: "#1e40af",
                        fontSize: "15px",
                        padding: "12px",
                        textAlign: "center",
                        fontWeight: "600",
                        border: "1px solid #bfdbfe",
                      }}
                    >
                      الكمية
                    </th>

                    <th
                      style={{
                        color: "#1e40af",
                        fontSize: "15px",
                        padding: "12px",
                        textAlign: "center",
                        fontWeight: "600",
                        border: "1px solid #bfdbfe",
                      }}
                    >
                      سعر الوحدة
                    </th>

                    <th
                      style={{
                        color: "#1e40af",
                        fontSize: "15px",
                        padding: "12px",
                        textAlign: "center",
                        fontWeight: "600",
                        border: "1px solid #bfdbfe",
                      }}
                    >
                      الإجمالي
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {purchase.items.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        background: index % 2 === 0 ? "#f8fafc" : "#ffffff",
                      }}
                    >
                      <td
                        style={{
                          padding: "12px",
                          border: "1px solid #e0e7ff",
                          fontSize: "15px",
                        }}
                      >
                        <div style={{ color: "#000", fontWeight: "600" }}>
                          {item.productName}
                        </div>

                        {item.productDescription && (
                          <div
                            style={{
                              color: "#64748b",
                              fontSize: "15px",
                              marginTop: "2px",
                              fontWeight: "600",
                            }}
                          >
                            {item.productDescription}
                          </div>
                        )}
                      </td>

                      <td
                        style={{
                          padding: "12px",
                          color: "#475569",
                          border: "1px solid #e0e7ff",
                          textAlign: "center",
                          fontSize: "17px",
                          fontWeight: "700",
                        }}
                      >
                        {item.categoryName}
                      </td>

                      <td
                        style={{
                          padding: "12px",
                          color: "#475569",
                          border: "1px solid #e0e7ff",
                          textAlign: "center",
                          fontSize: "17px",
                          fontWeight: "700",
                        }}
                      >
                        {item.brandName}
                      </td>

                      <td
                        style={{
                          padding: "12px",
                          border: "1px solid #e0e7ff",
                          textAlign: "center",
                          fontSize: "17px",
                          color: "#000",
                          fontWeight: "600",
                        }}
                      >
                        {item.quantity}
                      </td>

                      <td
                        style={{
                          padding: "12px",
                          border: "1px solid #e0e7ff",
                          textAlign: "center",
                          fontSize: "17px",
                          color: "#2563eb",
                          fontWeight: "600",
                        }}
                      >
                        {item.unitPrice.toLocaleString()} جنيه
                      </td>

                      <td
                        style={{
                          padding: "12px",
                          border: "1px solid #e0e7ff",
                          textAlign: "center",
                          fontSize: "16px",
                          color: "#1e40af",
                          fontWeight: "700",
                        }}
                      >
                        {item.subTotal.toLocaleString()} جنيه
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Payments Table */}
          {purchase.payments && purchase.payments.length > 0 && (
            <div style={{ marginBottom: "25px" }}>
              <h5
                style={{
                  color: "#2563eb",
                  fontSize: "18px",
                  fontWeight: "600",
                  marginBottom: "12px",
                }}
              >
                سجل الدفعات
              </h5>

              <div className="table-responsive">
                <table
                  className="table mb-0"
                  style={{ border: "1px solid #dbeafe" }}
                >
                  <thead>
                    <tr style={{ background: "#eff6ff" }}>
                      <th
                        style={{
                          color: "#1e40af",
                          fontSize: "15px",
                          padding: "10px",
                          fontWeight: "600",
                          border: "1px solid #bfdbfe",
                          textAlign: "center",
                        }}
                      >
                        المبلغ
                      </th>

                      <th
                        style={{
                          color: "#1e40af",
                          fontSize: "15px",
                          padding: "10px",
                          fontWeight: "600",
                          border: "1px solid #bfdbfe",
                          textAlign: "center",
                        }}
                      >
                        التاريخ
                      </th>

                      <th
                        style={{
                          color: "#1e40af",
                          fontSize: "15px",
                          padding: "10px",
                          fontWeight: "600",
                          border: "1px solid #bfdbfe",
                          textAlign: "center",
                        }}
                      >
                        طريقة الدفع
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {purchase.payments.map((p, index) => (
                      <tr key={index} style={{ background: "#ffffff" }}>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #e0e7ff",
                            textAlign: "center",
                            fontSize: "17px",
                            color: "#2563eb",
                            fontWeight: "700",
                          }}
                        >
                          {p.amount.toLocaleString()} جنيه
                        </td>

                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #e0e7ff",
                            textAlign: "center",
                            fontSize: "16px",
                            color: "#475569",
                          }}
                        >
                          {new Date(p.date).toLocaleDateString("ar-EG")}
                        </td>

                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #e0e7ff",
                            textAlign: "center",
                            fontSize: "16px",
                            color: "#000",
                            fontWeight: "500",
                          }}
                        >
                          {p.method}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {/* Total Summary */}
          <div
            style={{
              borderTop: "2px solid #93c5fd",
              paddingTop: "20px",
              marginTop: "10px",
              background: "#f8fafc",
              padding: "20px",
              borderRadius: "6px",
            }}
          >
            <div className="row mb-2">





  <div className="col-6">
                <span style={{ color: "#64748b", fontSize: "17px" }}>
                   الخصم:
                </span>
              </div>
              <div className="col-6 text-end">
                <span
                  style={{
                    color: "#1e40af",
                    fontSize: "22px",
                    fontWeight: "700",
                  }}
                >
                 {purchase?.discountAmount} جنيه
                </span>
              </div>



              <div className="col-6">
                <span style={{ color: "#64748b", fontSize: "17px" }}>
                  إجمالي المبلغ بعد الخصم:
                </span>
              </div>
              <div className="col-6 text-end">
                <span
                  style={{
                    color: "#1e40af",
                    fontSize: "22px",
                    fontWeight: "700",
                  }}
                >
                  {purchase.totalAmount.toLocaleString()} جنيه
                </span>
              </div>





            </div>

            <div className="row mb-2">
              <div className="col-6">
                <span style={{ color: "#64748b", fontSize: "17px" }}>
                  إجمالي المدفوع:
                </span>
              </div>
              <div className="col-6 text-end">
                <span
                  style={{
                    color: "#2563eb",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                >
                  {totalPaid.toLocaleString()} جنيه
                </span>
              </div>
            </div>

            <div
              className="row"
              style={{
                borderTop: "2px solid #cbd5e1",
                paddingTop: "12px",
                marginTop: "8px",
              }}
            >
              <div className="col-6">
                <span
                  style={{
                    color: "#64748b",
                    fontSize: "17px",
                    fontWeight: "600",
                  }}
                >
                  المتبقي:
                </span>
              </div>

              <div className="col-6 text-end">
                <span
                  style={{
                    color: remaining > 0 ? "#dc2626" : "#16a34a",
                    fontSize: "24px",
                    fontWeight: "700",
                  }}
                >
                  {remaining.toLocaleString()} جنيه
                </span>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div
            style={{
              marginTop: "30px",
              paddingTop: "20px",
              borderTop: "1px solid #e2e8f0",
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "13px",
            }}
          >
            <p style={{ margin: 0 }}>شكراً لتعاملك معنا!</p>
            <p style={{ margin: "4px 0 0 0" }}>
              تم الإنشاء بتاريخ {new Date().toLocaleString("ar-EG")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
